var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { Observable, Subject } from 'rxjs';
import { SelectChapter } from 'src/app/story/state/chapters/story.chapters.actions';
var ViewChaptersListComponent = /** @class */ (function () {
    function ViewChaptersListComponent(store) {
        this.store = store;
        this.ngUnsubscribe = new Subject();
    }
    ViewChaptersListComponent.prototype.ngOnInit = function () {
    };
    ViewChaptersListComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    ViewChaptersListComponent.prototype.handleChapterClick = function (chapter) {
        this.store.dispatch(new SelectChapter(chapter));
    };
    __decorate([
        Select(StoryChaptersState.getStoryChapters),
        __metadata("design:type", Observable)
    ], ViewChaptersListComponent.prototype, "chapters$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapter),
        __metadata("design:type", Observable)
    ], ViewChaptersListComponent.prototype, "selectedChapter$", void 0);
    __decorate([
        Select(StoryChaptersState.getRegisteredThumbnails),
        __metadata("design:type", Map)
    ], ViewChaptersListComponent.prototype, "thumbnails$", void 0);
    return ViewChaptersListComponent;
}());
export { ViewChaptersListComponent };
